import { render, staticRenderFns } from "./TransactionHistoryList.vue?vue&type=template&id=672a66ee"
import script from "./TransactionHistoryList.vue?vue&type=script&lang=js"
export * from "./TransactionHistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports